import $axios from '../services/apiLms.js'

const state = () => ({
    presences_teacher: [],
    total_teachers: 0,
    total_teachers_presence: 0,
})

const mutations = {
    ASSIGN_PRESENCES_TEACHER(state, payload) {
        state.presences_teacher = payload
    },
    ASSIGN_TOTAL_TEACHER(state, payload) {
        state.total_teachers = payload
    },
    ASSIGN_TOTAL_TEACHER_PRESENCE(state, payload) {
        state.total_teachers_presence = payload
    },
}

const actions = {
    getPresencesTeacher({ commit }, payload) {
        return new Promise((resolve) => {
            $axios.get(`kepsek/presensi/teacher`, {
                params: {
                    date: payload.date,
                    status: payload?.status ?? ""
                }
            })
                .then((response) => {
                    commit('ASSIGN_PRESENCES_TEACHER', response.data.data.presence)
                    commit('ASSIGN_TOTAL_TEACHER', response.data.data.total_teachers)
                    commit('ASSIGN_TOTAL_TEACHER_PRESENCE', response.data.data.total_teachers_presence)
                    resolve(response.data)
                })
        })
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}